import * as oidc from 'oidc-client-ts';
import config from '../config';

const isLocal = config.isLocal && config.isLocal();

const userManagerSettings: oidc.UserManagerSettings = {
  authority: config.AUTH_BASE_URL,
  automaticSilentRenew: !isLocal,
  monitorSession: !isLocal,
  client_id: 'sim-management-portal',
  filterProtocolClaims: true,
  loadUserInfo: true,
  redirect_uri: `${config.PORTAL_BASE_URL}/callback`,
  // oidc-client-ts supports the authorization code flow with PKCE only; implicit was removed in v2.
  response_type: 'code',
  scope: 'openid profile simmanage.api.internal',
  silent_redirect_uri: isLocal ? undefined : `${config.PORTAL_BASE_URL}/home/silentrenew`,
  post_logout_redirect_uri: config.PORTAL_BASE_URL,
};

const userManager = new oidc.UserManager(userManagerSettings);
export default userManager;
